import * as React from "react";

interface RadioGroupContext {
  isDisabled: boolean;
  isReadOnly: boolean;
  selectedValue: string | null;
  setSelectedValue(value: string): void;
  lastFocusedValue: string | null;
  setLastFocusedValue(value: string): void;
  name: string;
  isRequired?: boolean;
  validationState?: "error";
}

const Context = React.createContext<RadioGroupContext | undefined>(undefined);

export function RadioGroupProvider({
  children,
  ...props
}: React.PropsWithChildren<RadioGroupContext>) {
  return <Context.Provider value={props}>{children}</Context.Provider>;
}

export const useRadioGroupContext = () => {
  const context = React.useContext(Context);

  if (context === undefined) {
    throw new Error(
      "useRadioGroupContext: Please provide RadioGroupProvider value.",
    );
  }

  return context;
};
